<script setup lang="ts">
/**
 * H5LoadingSplash — the SoulSpace "loading" screen shown while a page loads.
 *
 * Wraps the shared BrandSplash (in @soulspc/ui) with the H5 loading state:
 * useRouteLoading flips it on while a lazy route chunk fetches (or the auth
 * guard round-trips) and off once navigation settles. The visual design lives
 * in BrandSplash so Admin renders the same screen.
 */
import { BrandSplash } from "@soulspc/ui";

import { useRouteLoading } from "@/composables/use-route-loading";

const routeLoading = useRouteLoading();
</script>

<template>
  <BrandSplash v-if="routeLoading" />
</template>

<style scoped>
.splash-fade-leave-active {
  transition: opacity 0.25s ease;
  pointer-events: none;
}

.splash-fade-leave-to {
  opacity: 0;
}
</style>
